import React from 'react';

import {Card, CardContent, Stack, Typography, Avatar, Box} from 'views/components';
import {Search, CalendarToday, Person, HeadsetMicOutlined} from 'views/icons';
import {Translate, translate, MarkdownViewer} from 'views/module';

const HowCareQuiltWorksCard = () => {
  return (
    <Card>
      <CardContent>
        <Stack spacing={3}>
          <Stack>
            <Typography component='div' variant='h6'>
              <Translate expression={'dashboard.sections.info.howCareQuiltWorksTitle'}/>
            </Typography>
            <Typography component='div' variant='body2' color='text.secondary'>
              <MarkdownViewer value={translate('dashboard.sections.info.howCareQuiltWorks')}/>
            </Typography>
          </Stack>

          <Box
            display='grid'
            gridTemplateColumns={{
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(4, 1fr)',
            }}
            height='content-fit'
            gap={2}
          >
            <Card sx={{bgcolor: 'background.default', pb: 3}}>
              <Stack spacing={2}>
                <Box>
                  <Avatar sx={{bgcolor: 'Background', mt: 2}}>
                    <Search sx={{color: 'InfoText'}}/>
                  </Avatar>
                </Box>
                <Stack>
                  <Typography component='div' variant='subtitle'>
                    <Translate expression={'dashboard.sections.info.identifyCareNeedsTitle'}/>
                  </Typography>
                  <Typography component='div' variant='body2' color='text.secondary'>
                    <MarkdownViewer value={translate('dashboard.sections.info.identifyCareNeeds')}/>
                  </Typography>
                </Stack>
              </Stack>
            </Card>
            <Card sx={{bgcolor: 'background.default', pb: 3}}>
              <Stack spacing={2}>
                <Box>
                  <Avatar sx={{bgcolor: 'Background', mt: 2}}>
                    <CalendarToday sx={{color: 'InfoText'}}/>
                  </Avatar>
                </Box>
                <Stack>
                  <Typography component='div' variant='subtitle'>
                    <Translate expression={'dashboard.sections.info.setRecurringScheduleTitle'}/>
                  </Typography>
                  <Typography component='div' variant='body2' color='text.secondary'>
                    <MarkdownViewer value={translate('dashboard.sections.info.setRecurringSchedule')}/>
                  </Typography>
                </Stack>
              </Stack>
            </Card>
            <Card sx={{bgcolor: 'background.default', pb: 3}}>
              <Stack spacing={2}>
                <Box>
                  <Avatar sx={{bgcolor: 'Background', mt: 2}}>
                    <Person sx={{color: 'InfoText'}}/>
                  </Avatar>
                </Box>
                <Stack>
                  <Typography component='div' variant='subtitle'>
                    <Translate expression={'dashboard.sections.info.perfectMatchTitle'}/>
                  </Typography>
                  <Typography component='div' variant='body2' color='text.secondary'>
                    <MarkdownViewer value={translate('dashboard.sections.info.perfectMatch')}/>
                  </Typography>
                </Stack>
              </Stack>
            </Card>
            <Card sx={{bgcolor: 'background.default', pb: 3}}>
              <Stack spacing={2}>
                <Box>
                  <Avatar sx={{bgcolor: 'Background', mt: 2}}>
                    <HeadsetMicOutlined sx={{color: 'InfoText'}}/>
                  </Avatar>
                </Box>
                <Stack>
                  <Typography component='div' variant='subtitle'>
                    <Translate expression={'dashboard.sections.info.ongoingSupportTitle'}/>
                  </Typography>
                  <Typography component='div' variant='body2' color='text.secondary'>
                    <MarkdownViewer value={translate('dashboard.sections.info.ongoingSupport')}/>
                  </Typography>
                </Stack>
              </Stack>
            </Card>
          </Box>

          <Stack>
            <Typography component='div' variant='subtitle'>
              <Translate expression={'dashboard.sections.info.mutualOptInAdvantageTitle'}/>
            </Typography>
            <Typography component='div' variant='body2' color='text.secondary'>
              <MarkdownViewer value={translate('dashboard.sections.info.mutualOptInAdvantage')}/>
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default HowCareQuiltWorksCard;
